import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/components/layout/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollCTA"] */ "/vercel/path0/components/modals/scrollCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
